// Copyright (c) 2022 by Move Closer

import { ComputedRef, Ref, WritableComputedRef } from '@vue/composition-api'

import {
  AbstractCheckControlModelType,
  AbstractCheckControlProps,
  AbstractCheckControlType
} from '../../abstract/components/CheckControl/CheckControl.contracts'
import { FormControlModelType } from '../../abstract/general'

import { CanHaveTheme } from '../../composables'

export type CheckProps = AbstractCheckControlProps<FormControlModelType> & CanHaveTheme

export interface UseCheckProvides<ModelType> {
  checked: WritableComputedRef<AbstractCheckControlModelType<ModelType>>
  checkType: Ref<AbstractCheckControlType>
  checkValue: ComputedRef<ModelType>
  hasErrors: ComputedRef<boolean>
  isActive?: ComputedRef<boolean>
  themeClass?: ComputedRef<string>
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum CheckTheme {
  Primary = '',
  Secondary = 'secondary'
}
